import type { Components } from '@mui/material/styles';
import type { Theme } from '../types';

export const MuiListItemButton = {
    styleOverrides: {
        root: {
            '&.Mui-selected': {
                backgroundColor: 'var(--mui-list-item-button-bg-selected)',
                '&:hover': {
                    backgroundColor: 'var(--mui-list-item-button-bg-selected-hover)',
                },
            },
        },
    },
} satisfies Components<Theme>['MuiListItemButton'];
